<template>
	<vs-prompt
		@cancel="clearValues"
		@accept="acceptAlert"
		@close="close"
		:is-valid="isValid"
		:active.sync="active_prompt"
		:title="$t('Waypoint.WaypointInformation')"
		:accept-text="is_edit ? $t('Update') : $t('Accept')"
		:cancel-text="$t('Cancel')"
	>
		<div class="con-exemple-prompt">
			{{ $t("Waypoint.EnterWaypointInformation") }}

			<div class="vx-row mb-2 mt-4">
				<div class="vx-col w-full">
					<small class="date-label">{{ $t("Waypoint.job_type") }}</small>
					<v-select
						label-placeholder="Job Type"
						v-model="jobType"
						:options="options"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
						class="w-full"
						:clearable="false"
					/>
				</div>
			</div>

			<div class="vx-row mb-2">
				<div class="vx-col w-full">
					<small class="date-label">{{ $t("Waypoint.service_time") }}</small>
					<flat-pickr
						:config="configDateTimePicker"
						v-model="waypoint.service_time"
						label-placeholder="Choose time"
						class="w-full"
					/>
				</div>
			</div>
			<FormGeo
				v-if="origin === 'geo'"
				:autoAddMarker="false"
				:setDataGeo="setDataGeo"
				:getDataGeo="true"
				:showDataGeoAlert="showDataGeoAlert"
				:data="waypoint"
			></FormGeo>

			<vs-alert
				:active.sync="geoAlert"
				:color="geoAlertColor"
				vs-icon="new_releases"
				class="mt-2"
				closable
				icon-pack="feather"
				close-icon="icon-x"
			>
				{{ geoAlertText }}
			</vs-alert>
		</div>
	</vs-prompt>
</template>

<script>
import Waypoint from "@/models/Waypoint";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import FormGeo from "@/components/zonification/FormGeo.vue";

export default {
	props: {
		wpData: {
			type: Object,
			required: false,
		},
		activePrompt: {
			type: Boolean,
			required: false,
			default: false,
		},
		isEdit: {
			type: Boolean,
			required: false,
			default: false,
		},
		origin: {
			type: String,
			required: false,
			default: "geo",
		},
	},
	components: {
		flatPickr,
		vSelect,
		FormGeo,
	},
	data() {
		return {
			time: null,
			configDateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
				time_24hr: true,
			},
			waypoint: this.wpData,
			jobType: {id: "PICKUP", label: this.$t("Waypoint.Pickup")},
			geoAlert: false,
			geoAlertText: "",
			geoAlertColor: null,
		};
	},
	computed: {
		isValid() {
			return this.origin === "geo"
				? this.waypoint.isValid() && this.geoAlertColor !== "danger"
				: this.waypoint.isValid();
		},
		active_prompt: {
			get() {
				return this.activePrompt;
			},
			set(value) {
				this.$emit("close");
			},
		},
		options() {
			return [
				{id: "PICKUP", label: this.$t("Waypoint.Pickup")},
				{id: "DELIVERY", label: this.$t("Waypoint.Delivery")},
			];
		},
		is_edit() {
			return this.isEdit;
		},
	},
	methods: {
		acceptAlert() {
			this.$emit("accept", {...this.waypoint}, this.isEdit ? "edit" : "add");
		},
		close() {
			this.$emit("close");
		},
		clearValues() {
			this.$emit("cancel");
		},
		setDataGeo(data) {
			this.waypoint.setLatitude(data.cy).setLongitude(data.cx);
		},

		showDataGeoAlert(text, color) {
			this.geoAlert = true;
			this.geoAlertColor = color;
			this.geoAlertText = text;
		},
	},
	watch: {
		jobType(value) {
			this.waypoint.setJobType(value.id);
		},
	},
	mounted() {
		if (this.is_edit) {
			this.waypoint = new Waypoint(this.wpData);
			const jobType = this.waypoint.job_type;
			this.jobType = {
				id: jobType,
				label: jobType === "PICKUP" ? this.$t("Waypoint.Pickup") : this.$t("Waypoint.Delivery"),
			};
		}
	},
};
</script>
